import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';

/**
 * Renders the "Scope & Focus" testing instructions block.
 * @param {object} props
 * @param {object} props.instructions - raw JSON fetched from /website/:id/testing-instructions
 * @param {boolean} [props.collapsible=true]
 * @param {boolean} [props.defaultOpen=true]
 */
function ScopeFocusInstructions({ instructions, collapsible = true, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);

  const scope = instructions?.scope_and_focus;
  if (!scope) return null;

  const body = (
    <div className="p-3" style={{ background: '#fff' }}>
      {scope.website_name && (
        <div style={{ fontSize: '1rem', fontWeight: 700, color: '#212529', marginBottom: 2 }}>
          {scope.website_name}
        </div>
      )}
      {scope.summary && (
        <p style={{ fontSize: '0.88rem', color: '#555', marginBottom: 10, fontStyle: 'italic' }}>
          {scope.summary}
        </p>
      )}
      {scope.intro && (
        <p style={{ fontSize: '0.88rem', color: '#333', marginBottom: 10 }}>{scope.intro}</p>
      )}

      {scope.focus_features?.length > 0 && (
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
          {scope.focus_features.map((feature, i) => (
            <li key={i} style={{ fontSize: '0.9rem', color: '#222', marginBottom: 4, fontWeight: 500 }}>
              {feature}
            </li>
          ))}
        </ul>
      )}

      {scope.note && (
        <div className="mb-3 p-3" style={{ background: '#fff8f0', border: '1px solid #ffe0b2', borderRadius: 8 }}>
          <p style={{ fontSize: '0.82rem', color: '#333', marginBottom: 0 }}>💡 {scope.note}</p>
        </div>
      )}

      {scope.ground_rules?.length > 0 && (
        <div style={{ fontSize: '0.85rem', color: '#333' }}>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>Ground rules:</div>
          <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
            {scope.ground_rules.map((rule, i) => (
              <li key={i} style={{ marginBottom: 3 }}>{rule}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  return (
    <div className="mb-4" style={{ borderRadius: 10, border: '1px solid #dee2e6', overflow: 'hidden' }}>
      <div
        className="d-flex align-items-center justify-content-between px-3 py-2"
        style={{ background: '#f8f9fa', cursor: collapsible ? 'pointer' : 'default', userSelect: 'none' }}
        onClick={() => collapsible && setOpen(v => !v)}
      >
        <span style={{ fontWeight: 600, fontSize: '0.95rem' }}>🎯 Scope & Focus Instructions</span>
        {collapsible && (
          <span style={{ fontSize: '0.8rem', color: '#6c757d' }}>{open ? '▲ collapse' : '▼ expand'}</span>
        )}
      </div>

      {collapsible ? <Collapse in={open}>{body}</Collapse> : body}
    </div>
  );
}

export default ScopeFocusInstructions;
